import clsx from "clsx";

const Section = ({ className, children, asMain }) => {
  const Tag = asMain ? "main" : "div";
  return (
    <Tag className={clsx("px-4 sm:px-6 lg:px-10", className)}>
      <div className="max-w-7xl mx-auto">{children}</div>
    </Tag>
  );
};

export default Section;
